import { Injectable } from '@angular/core';
import { Observable,of } from 'rxjs';
import { Config } from './app.models';
import { config } from '../environments/environment';

@Injectable()
export class ConfigService {

    getPolicyInfoConfig(): Observable<Config> {
        return of(config);
    }
}
